document.addEventListener('DOMContentLoaded', function () {
  const bar = document.querySelector('[data-pr-sticky-atc]');
  const root = document.querySelector('[data-pr-pdp]');
  if (!bar || !root) return;

  // The A/B test's treatment buy box (pr-buybox.liquid) has its own markup
  // rather than the shared widget, and marks the same parts with data-pr-ybox-*
  // hooks; every lookup below takes either, so the bar does not care which one
  // it mirrors.
  const widget = root.querySelector('.custom-subscription-widget-container, [data-pr-ybox]');
  const form = root.querySelector('.product-single__form');
  const submit = form && form.querySelector('.btn--add-to-cart');
  if (!widget || !form || !submit) {
    bar.remove();
    return;
  }

  // Subscription cards only -- Buy Once is not sold from the bar.
  const cards = Array.prototype.slice
    .call(
      widget.querySelectorAll(
        '.subscription-options-list .purchase-option-label:not(.purchase-option-onetime), [data-pr-ybox-card]'
      )
    )
    .filter(function (card) {
      return card.querySelector('input[name="purchase_option"]');
    });

  // No subscriptions on this product: the bar would have nothing to add.
  if (!cards.length) {
    bar.remove();
    return;
  }

  const field = bar.querySelector('[data-pr-sticky-field]');
  const toggle = bar.querySelector('[data-pr-sticky-toggle]');
  const menu = bar.querySelector('[data-pr-sticky-menu]');
  const titleEl = bar.querySelector('[data-pr-sticky-title]');
  const subEl = bar.querySelector('[data-pr-sticky-sub]');
  const addButton = bar.querySelector('[data-pr-sticky-add]');
  const multiple = cards.length > 1;

  // position: fixed is measured against the nearest transformed ancestor, and
  // the PDP wraps its sections in .pr-reveal, whose visible state is a
  // translateY. Left in place the bar would scroll away with the section, so it
  // is reparented to the body where nothing can trap it. Any bar left on the
  // body by an earlier render goes first -- the theme editor re-renders the
  // section without reloading the page, which would otherwise stack them up.
  document.querySelectorAll('[data-pr-sticky-atc]').forEach(function (stale) {
    if (stale !== bar) stale.remove();
  });
  document.body.appendChild(bar);

  const radioFor = function (card) {
    return card.querySelector('input[name="purchase_option"]');
  };

  // The card's plain title -- "90-Day Supply". Its Save pill is a child of the
  // same element, so it is lifted out before the text is read.
  const nameOf = function (card) {
    const label = card.querySelector('.main-label, [data-pr-ybox-name]');
    if (!label) return '';
    const copy = label.cloneNode(true);
    const pill = copy.querySelector('.savings-label');
    if (pill) pill.remove();
    return copy.textContent.replace(/\s+/g, ' ').trim();
  };

  const savingOf = function (card) {
    const pill = card.querySelector('.savings-label, [data-pr-ybox-badge]');
    if (!pill || pill.style.display === 'none') return '';
    return pill.textContent.replace(/\s+/g, ' ').trim();
  };

  // Whatever the flavour script last wrote into the card, "/mo" included.
  const priceOf = function (card) {
    const price = card.querySelector('.current-price-display, [data-pr-ybox-price]');
    const perMo = card.querySelector('.price-per-mo, [data-pr-ybox-per]');
    const amount = price ? price.textContent.trim() : '';
    const suffix = perMo ? perMo.textContent.trim() : '';
    return amount + suffix;
  };

  let selectedIndex = 0;

  const checkedIndex = function () {
    for (let i = 0; i < cards.length; i++) {
      const radio = radioFor(cards[i]);
      if (radio && radio.checked) return i;
    }
    // Buy Once is selected in the buy box, so no card is: keep showing the last
    // offer the shopper looked at rather than jumping back to the first.
    return selectedIndex;
  };

  if (multiple) {
    cards.forEach(function (card, i) {
      const option = document.createElement('li');
      option.className = 'pr-sticky-atc__option';
      option.setAttribute('role', 'option');
      option.setAttribute('tabindex', '-1');
      option.dataset.prStickyOption = String(i);
      menu.appendChild(option);
    });
  } else {
    // One offer: there is nothing to choose, but the shopper still has to see
    // what Add is about to add. The pill stays and becomes a plain label --
    // lifted out of its <button> so nothing announces or focuses a control
    // that does nothing. The display children (and so the titleEl/subEl
    // references above) move across untouched.
    const label = document.createElement('span');
    label.className = 'pr-sticky-atc__toggle pr-sticky-atc__toggle--static';
    while (toggle.firstChild) label.appendChild(toggle.firstChild);
    const chevron = label.querySelector('.pr-sticky-atc__chevron');
    if (chevron) chevron.remove();
    toggle.replaceWith(label);
    menu.remove();
  }
  field.hidden = false;

  const setOpen = function (open) {
    if (!multiple) return;
    field.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.hidden = !open;
  };

  // Prices are written by the flavour scripts on every change, so every label is
  // rebuilt from the cards instead of being cached.
  const sync = function () {
    // A sold-out variant disables the real button; the bar must not look live
    // while clicking it does nothing.
    addButton.disabled = submit.disabled;

    if (multiple) {
      selectedIndex = checkedIndex();

      cards.forEach(function (card, i) {
        const option = menu.children[i];
        if (!option) return;
        // The panel lists offers by name only -- the price for the one in hand
        // is already on the closed pill, two lines below it.
        option.textContent = nameOf(card);
        option.setAttribute('aria-selected', i === selectedIndex ? 'true' : 'false');
        option.classList.toggle('is-selected', i === selectedIndex);
      });
    }

    const current = cards[selectedIndex];
    if (!current) return;
    const saving = savingOf(current);
    if (titleEl) titleEl.textContent = saving ? nameOf(current) + ' (' + saving + ')' : nameOf(current);
    if (subEl) subEl.textContent = priceOf(current);
  };

  // Selecting in the bar selects in the buy box, through the same change event
  // every existing listener already watches.
  const choose = function (card) {
    const radio = radioFor(card);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const pick = function (index) {
    const card = cards[index];
    if (!card) return;
    selectedIndex = index;
    choose(card);
    // Buy Once may have been the selection, in which case choose() changed
    // nothing in the buy box and no change event came back to refresh the
    // display. Update it from here either way.
    sync();
    setOpen(false);
    toggle.focus();
  };

  if (multiple) {
    toggle.addEventListener('click', function () {
      setOpen(menu.hidden);
    });

    menu.addEventListener('click', function (event) {
      const option = event.target.closest('[data-pr-sticky-option]');
      if (option) pick(parseInt(option.dataset.prStickyOption, 10));
    });

    field.addEventListener('keydown', function (event) {
      const options = Array.prototype.slice.call(menu.children);
      const focused = options.indexOf(document.activeElement);

      if (event.key === 'Escape') {
        setOpen(false);
        toggle.focus();
        return;
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (menu.hidden) {
          setOpen(true);
          (options[selectedIndex] || options[0]).focus();
          return;
        }
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = options[(focused + step + options.length) % options.length];
        if (next) next.focus();
        return;
      }

      if ((event.key === 'Enter' || event.key === ' ') && focused > -1) {
        event.preventDefault();
        pick(focused);
      }
    });

    // Anywhere else on the page dismisses it, the way a real picker does.
    document.addEventListener('click', function (event) {
      if (!field.contains(event.target)) setOpen(false);
    });
  }

  addButton.addEventListener('click', function () {
    // Synchronous: the flavour listeners run inside this dispatch, so the form's
    // variant and selling plan are settled before the submit fires.
    choose(cards[selectedIndex]);
    // The bar has no form of its own -- it adds by clicking the buy box's own
    // button, so product-form.js cannot tell the two apart. Stamp the form on
    // the way in; the submit handler reads it and clears it in the same tick.
    form.dataset.prAtcSource = 'sticky_bar';
    submit.click();
  });

  // The flavour scripts rewrite prices in their own change listeners, which are
  // bound to the radios themselves and so run before this one on the form.
  form.addEventListener('change', function () {
    sync();
  });

  sync();

  // Up from the start rather than revealed on scroll, so the offer and the price
  // are never off screen. The body padding keeps it clear of the last of the
  // page; both are undone above 749px in pure-rose-pdp.css.
  bar.hidden = false;
  document.body.classList.add('pr-has-sticky-atc');
});
